/* Capsule Autasia v33 consolidated interaction layer. */

/* === autasia-flow-v30.js === */
(()=>{
  const d=document,html=d.documentElement;
  const reduced=matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Scroll direction: reclaim mobile viewport on downward browsing, restore search on intent to go back. */
  let lastY=scrollY,raf=0;
  const updateScroll=()=>{
    const y=scrollY;
    const delta=y-lastY;
    if(y<80){html.classList.remove('v30-scroll-down');}
    else if(delta>7){html.classList.add('v30-scroll-down');}
    else if(delta<-7){html.classList.remove('v30-scroll-down');}
    lastY=y;
    raf=0;
  };
  addEventListener('scroll',()=>{if(!raf)raf=requestAnimationFrame(updateScroll);},{passive:true});

  /* Intent prefetch: small same-origin cache warmup for products/collections/pages. */
  if('HTMLLinkElement' in window && !navigator.connection?.saveData && !/2g/.test(navigator.connection?.effectiveType||'')){
    const prefetched=new Set();
    let timer=0,pending='';
    const eligible=anchor=>{
      if(!anchor?.href||anchor.target==='_blank'||anchor.hasAttribute('download'))return '';
      const u=new URL(anchor.href,location.href);
      if(u.origin!==location.origin||u.href===location.href||u.hash&&u.pathname===location.pathname)return '';
      if(/\/cart(?:\/|$)|\/account(?:\/|$)|\/search(?:\?|$)|\/checkout/i.test(u.pathname))return '';
      return u.href;
    };
    const prefetch=url=>{
      if(!url||prefetched.has(url)||prefetched.size>=8)return;
      prefetched.add(url);
      const link=d.createElement('link');
      link.rel='prefetch';link.href=url;link.as='document';
      d.head.appendChild(link);
    };
    d.addEventListener('pointerover',e=>{
      if(e.pointerType==='touch')return;
      const url=eligible(e.target.closest('a'));
      if(!url)return;
      pending=url;clearTimeout(timer);timer=setTimeout(()=>prefetch(pending),90);
    },{passive:true});
    d.addEventListener('pointerout',()=>{clearTimeout(timer);pending='';},{passive:true});
    d.addEventListener('pointerdown',e=>{const url=eligible(e.target.closest('a'));if(url)prefetch(url);},{passive:true});
  }

  /* Make horizontal rails keyboard-friendly without adding a library. */
  d.querySelectorAll('.category-rail--capsules,.store-category-grid,.life-grid,[data-studio-viewport]').forEach(rail=>{
    if(!rail.hasAttribute('tabindex'))rail.tabIndex=0;
    rail.addEventListener('keydown',e=>{
      if(e.key!=='ArrowLeft'&&e.key!=='ArrowRight')return;
      if(e.target!==rail)return;
      e.preventDefault();
      const amount=Math.max(220,rail.clientWidth*.72)*(e.key==='ArrowRight'?1:-1);
      rail.scrollBy({left:amount,behavior:reduced?'auto':'smooth'});
    });
  });
})();


/* === autasia-experience-v31.js === */
(()=>{
  const d=document,html=d.documentElement;
  const reduced=matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Immediate navigation acknowledgement without hijacking Shopify navigation. */
  const progress=d.createElement('div');
  progress.className='ca31-nav-progress';progress.setAttribute('aria-hidden','true');
  d.body.appendChild(progress);
  const isPlainNavigation=(event,anchor)=>{
    if(!anchor?.href||event.defaultPrevented||event.button>0||event.metaKey||event.ctrlKey||event.shiftKey||event.altKey)return false;
    if(anchor.target&&anchor.target!=='_self'||anchor.hasAttribute('download'))return false;
    const url=new URL(anchor.href,location.href);
    if(url.origin!==location.origin)return false;
    if(url.pathname===location.pathname&&url.search===location.search&&url.hash)return false;
    return true;
  };
  d.addEventListener('click',event=>{
    const anchor=event.target.closest('a');
    if(isPlainNavigation(event,anchor))html.classList.add('v31-navigating');
  });
  addEventListener('pageshow',()=>html.classList.remove('v31-navigating'));

  /* Smart edge cues on horizontal rails. */
  const rails=[...d.querySelectorAll('.category-rail--capsules,.store-category-grid,.life-grid,[data-studio-viewport],.product-gallery__thumbs')];
  const syncRail=rail=>{
    const max=Math.max(0,rail.scrollWidth-rail.clientWidth);
    rail.classList.add('v31-rail');
    rail.classList.toggle('has-overflow',max>10);
    rail.classList.toggle('is-at-start',rail.scrollLeft<=5);
    rail.classList.toggle('is-at-end',rail.scrollLeft>=max-5);
  };
  rails.forEach(rail=>{
    let frame=0;
    const sync=()=>{if(frame)return;frame=requestAnimationFrame(()=>{syncRail(rail);frame=0;});};
    rail.addEventListener('scroll',sync,{passive:true});syncRail(rail);
    if('ResizeObserver'in window)new ResizeObserver(sync).observe(rail);
  });

  /* Warm the next hero image only when the connection can afford it. */
  const warmHero=()=>{
    if(navigator.connection?.saveData||/2g/.test(navigator.connection?.effectiveType||''))return;
    const image=d.querySelectorAll('[data-hero-slide] img')[1];
    if(!image||image.complete)return;
    const preload=new Image();preload.decoding='async';preload.src=image.currentSrc||image.src;
  };
  if('requestIdleCallback'in window)requestIdleCallback(warmHero,{timeout:1300});else setTimeout(warmHero,700);

  /* Cart counter micro-feedback, useful across drawer, quick add and PDP. */
  d.querySelectorAll('[data-cart-count]').forEach(counter=>{
    let previous=counter.textContent;
    new MutationObserver(()=>{
      const next=counter.textContent;if(next===previous)return;previous=next;
      counter.classList.remove('v31-pulse');void counter.offsetWidth;counter.classList.add('v31-pulse');
    }).observe(counter,{childList:true,characterData:true,subtree:true});
  });

  /* Avoid smooth-scroll work for reduced motion and during active gestures. */
  if(reduced)rails.forEach(rail=>rail.style.scrollBehavior='auto');
})();



/* === Capsule Autasia v33 · small quality-of-life layer === */
(()=>{
  const d=document;
  /* External links always open safely; theme-authored links already do, this covers app blocks too. */
  d.querySelectorAll('a[target="_blank"]').forEach(a=>{
    const rel=new Set((a.getAttribute('rel')||'').split(/\s+/).filter(Boolean));
    rel.add('noopener');
    a.setAttribute('rel',[...rel].join(' '));
  });

  /* Account shortcut to the order history scrolls with context and moves focus for keyboard users. */
  d.querySelectorAll('a[href="#AccountOrdersTitle"]').forEach(a=>a.addEventListener('click',e=>{
    const target=d.getElementById('AccountOrdersTitle');
    if(!target)return;
    e.preventDefault();
    target.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth',block:'start'});
    target.setAttribute('tabindex','-1');
    target.focus({preventScroll:true});
  }));
})();
